var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 134,
    viewBox: "0 0 151 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.1138 9.15527e-05C30.0491 9.15527e-05 0.000488281 30.047 0.000488281 67.112C0.000488281 104.177 30.0481 134.224 67.1138 134.224C93.6504 134.222 117.693 118.586 128.456 94.331H121.689C110.915 115.977 88.3873 129.231 64.2328 128.139C30.5281 126.548 4.49358 97.935 6.08461 64.23C7.67664 30.526 36.2902 4.493 69.9949 6.0845C92.0883 7.1587 111.875 20.09 121.728 39.893H128.456C117.693 15.6387 93.6504 0.00219155 67.1138 9.15527e-05Z",
    fill: "url(#paint0_linear_1_25)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M135.903 71.19C127.695 71.19 121.041 68.682 121.041 65.588C121.041 62.493 127.695 59.985 135.903 59.985C144.111 59.985 150.766 62.493 150.766 65.588C150.766 68.682 144.111 71.19 135.903 71.19Z",
    fill: "#01913A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_25",
    x1: 0.000488281,
    y1: 67.112,
    x2: 134.228,
    y2: 67.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FF10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.216028,
    stopColor: "#01913A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01913A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2189b84bc8f728b4bbf2fec0d4131870.svg";
export { ForwardRef as ReactComponent };